import { Button, Tooltip } from '~/shared/ui'

interface SubmitButtonProps {
  isDisabled: boolean
  onSubmit: () => void
  label: string
  tooltip?: string
  onErrorReset?: () => void
}

export function SubmitButton({
  isDisabled,
  onSubmit,
  label,
  tooltip,
  onErrorReset,
}: SubmitButtonProps) {
  const submitButton = (
    <Button
      size="small"
      raised
      disabled={isDisabled}
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
        onSubmit()
        onErrorReset?.()
      }}
    >
      {label}
    </Button>
  )

  return tooltip && isDisabled ? (
    <Tooltip
      content={tooltip}
      delayDuration={0}
    >
      <div>{submitButton}</div>
    </Tooltip>
  ) : (
    submitButton
  )
}
